/* eslint-disable import/prefer-default-export */

export const API_KEY = process.env.GOOGLE_MAPS_API_KEY;

export const DEFAULT_ZOOM = 6;

export const initialCenter = {
  lat: 52.325466,
  lng: 0,
};
